import React from 'react'
import { Helmet } from 'react-helmet'
import Layout from '../components/layouts/Layout'
import vdo from "../assets/KFE.mp4"
import AboutSection from '../components/AboutSection'
import ServicesSection from '../components/ServicesSection'
import TeamSection from '../components/TeamSection'
import ClientsSection from '../components/ClientsSection'
import ContactSection from '../components/ContactSection'
import LearnWithUsSection from '../components/LearnWithUsSection'
import YouTubeGridAutoPlay from '../components/YouTubeGridAutoPlay'
import SubscribePopup from '../components/SubscribePopup'
import Testimonial from '../components/Testmonial'
import GallerySection from '../components/GallerySection'

function Home() {
  return (
    <div>
      <Helmet> <title>Kaanshi Films Entertainment (KFE) | Film & Video Production House Mumbai</title> </Helmet>
       <Layout>
         <video className='h-full w-full' src={vdo} autoPlay muted>
         </video>
         <SubscribePopup/>
         <AboutSection/>
         <ServicesSection/>
         <TeamSection/>
         <ClientsSection/>
         <Testimonial/>
         <ContactSection/>
         <YouTubeGridAutoPlay/>
         <LearnWithUsSection/>
       </Layout>
    </div>
  )
}

export default Home
